import type { IconData } from '@stacksjs/iconify-core'

export const boxWaterproof: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-width=\"3\"><path d=\"M12.28 41.493a3.46 3.46 0 0 0 3.227 3.228c1.902.14 4.731.279 8.493.279s6.59-.139 8.493-.28a3.46 3.46 0 0 0 3.228-3.227C35.86 39.591 36 36.762 36 33s-.139-6.59-.28-8.493a3.46 3.46 0 0 0-3.227-3.228C30.591 21.14 27.762 21 24 21s-6.59.139-8.493.28a3.46 3.46 0 0 0-3.228 3.227C12.14 26.409 12 29.238 12 33s.139 6.59.28 8.493ZM30 39h-6m6-5h-4M23 3l3 3m10 0l3 3M10 6l3 3\"/><path stroke-linejoin=\"round\" d=\"M3 21s5-8 21-8s21 8 21 8\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default boxWaterproof
